import { Box, Grid, Typography } from "@mui/joy";

const HeadTable = ({ heads, theme }) => {
    return (
        <Box width="100%">
            <Grid container spacing={2} columns={heads.length} sx={{ flexGrow: 1 }}>
                {heads.map((head, index) => (
                    <Grid display="flex" justifyContent="center" key={index} xs={1}>
                        <Typography sx={{
                            fontFamily: "Montserrat",
                            fontSize: "12px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "150%",
                            color: theme.vars.palette.text.main,
                            textAlign: "center"
                        }}>
                            {head}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default HeadTable;